import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";

// GET AREAS
export const getAreas = async () => {
    const response = await PrivateInterceptor('area', 'GET');
    return response
} 

export const getPublicAreas = async(token) => {
    const result = await PublicInterceptor('area', 'GET', {}, token)
    return result;
}